import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AddBlock } from '@lyearn/molecules';
import { Stack } from '@lyearn/ui';
import DraggableList from '@/modules/corporate/components/DraggableList';
import { QuestionEditorProps } from '@/modules/corporate/modules/questions/fields/types';

import { addOptionStyles } from '../../components/Editor/styles';
import useMtfComponentAction from '../hooks/useMtfComponentActions';
import EditorOptionsListItem from './components/MtfEditorOptionsListItem';

const CLASSES = { itemDropOverContainer: '-ms-24' };

const MtfEditorOptionsList = (props: QuestionEditorProps) => {
  const { t } = useTranslation();
  const { viewMode, className } = props;
  const { mtfElements, onAction, onAddOption, onDrop } = useMtfComponentAction(props);

  return (
    <Stack className={className} direction="col" justifyContent="between">
      <DraggableList
        allowDropOnStart
        className="flex-1"
        classes={CLASSES}
        renderItem={(index, getDragHandleProps) => {
          const { leftElement, rightElement } = mtfElements[index];

          return (
            <EditorOptionsListItem
              key={`${mtfElements[index].tempId}_${index}`}
              getDragHandleProps={getDragHandleProps}
              index={index}
              leftElement={leftElement}
              rightElement={rightElement}
              viewMode={viewMode}
              onAction={onAction}
            />
          );
        }}
        totalCount={mtfElements.length}
        onDrop={onDrop}
      />
      {viewMode !== 'create' ? null : (
        <AddBlock
          className={addOptionStyles}
          title={t('QuizCreator:AddClueAndMatch')}
          onClick={onAddOption}
        />
      )}
    </Stack>
  );
};

export default MtfEditorOptionsList;
